import { MarketingCard, ScrollView, ScrollViewItem } from '@ace-clublabs/shared-component-library';

export const NewJoinScrollView = () => {
  return (
    <ScrollView
      sx={{
        '&>.MuiButtonBase-root.MuiIconButton-root': {
          background: 'rgba(255, 255, 255, 0.6)',
          top: '30%',
          zIndex: 1,
        },
        paddingLeft: '2px',
      }}
    >
      <ScrollViewItem sx={{ width: 'min(max(32vw, 17.5rem), 17.5rem)' }}>
        <MarketingCard
          cardVariant="identity-theft"
          sx={{ '& .css-0': { display: 'flex', flexDirection: 'column', whiteSpace: 'break-spaces' } }}
        />
      </ScrollViewItem>
      <ScrollViewItem sx={{ width: 'min(max(32vw, 17.5rem), 17.5rem)' }}>
        <MarketingCard cardVariant="hertz" sx={{ '& .css-0': { display: 'flex', flexDirection: 'column' } }} />
      </ScrollViewItem>
      <ScrollViewItem sx={{ width: 'min(max(32vw, 17.5rem), 17.5rem)' }}>
        <MarketingCard cardVariant="tickets" sx={{ '& .css-0': { display: 'flex', flexDirection: 'column' } }} />
      </ScrollViewItem>
    </ScrollView>
  );
};
